import { Link } from 'react-router';

import { navigation } from '@/pages/unauthenticated/components/navigation/constants';

export const FooterNavLinks = () => {
  return navigation.map((link) => {
    return (
      <Link key={link.href} to={link.href}>
        {link.name}
      </Link>
    );
  });
};
